const UnauthorizedPage = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "16px",
        background: "#fafafa",
        fontFamily: 'var(--font-family)',
      }}
    >
      <div>
        <h2 style={{fontSize: "20px"}}>Your access request is under review.</h2>
        <p style={{fontSize: "20px"}}>You'll be able to sign in once approval is complete.</p>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
